import type { Party } from '../types/case';
import { resolveSpeaker } from '../lib/speakers';

interface Props {
  speakerLabel: string;
  partyId: string | null;
  parties: Party[];
}

const SPEAKER_COLORS = [
  'bg-gray-100 text-gray-900',     // mediator (speaker_0) — neutral
  'bg-indigo-100 text-indigo-900',
  'bg-emerald-100 text-emerald-900',
  'bg-amber-100 text-amber-900',
  'bg-rose-100 text-rose-900',
  'bg-cyan-100 text-cyan-900',
  'bg-violet-100 text-violet-900',
];

const speakerIndex = (label: string): number => {
  const m = /(\d+)$/.exec(label);
  return m ? Number(m[1]) : 0;
};

/**
 * Shows the resolved speaker name — "Mediator", the matched party's name, or
 * a generic "Speaker N" fallback. Colors are consistent across the session.
 */
export function SpeakerBadge({ speakerLabel, partyId, parties }: Props) {
  const idx = speakerIndex(speakerLabel);
  const color = SPEAKER_COLORS[idx % SPEAKER_COLORS.length];

  let label: string;
  if (partyId) {
    label = parties.find((p) => p.id === partyId)?.name ?? resolveSpeaker(speakerLabel, parties).name;
  } else {
    label = resolveSpeaker(speakerLabel, parties).name;
  }

  return (
    <span
      className={`inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium ${color}`}
    >
      {label}
    </span>
  );
}
